// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2rVMq","content":"Consent_content__3rNAB","footer":"Consent_footer__19xEj"};